var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "LoadingOverlay",
    { attrs: { hasData: !!_vm.projects, loading: _vm.loading } },
    [
      _c(
        "div",
        { staticClass: "hidden sm:block w-8/12 mb-6" },
        [
          _c("RadioButtonGroup", {
            attrs: { options: _vm.radioOptions },
            model: {
              value: _vm.currentProjectStatus,
              callback: function ($$v) {
                _vm.currentProjectStatus = $$v
              },
              expression: "currentProjectStatus",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "sm:hidden" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.currentProjectStatus,
                expression: "currentProjectStatus",
              },
            ],
            staticClass:
              "mt-1 form-select status-dropdown block text-base leading-6 border-hover-yellow bg-hover-yellow focus:outline-none sm:text-sm transition ease-in-out duration-150",
            attrs: { "aria-label": "Selected tab" },
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.currentProjectStatus = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          _vm._l(_vm.radioOptions, function (option, i) {
            return _c("option", { key: i, domProps: { value: option.value } }, [
              _vm._v(
                " " + _vm._s(option.label) + " (" + _vm._s(option.total) + ") "
              ),
            ])
          }),
          0
        ),
      ]),
      _c("ProjectCollectionFilters", {
        attrs: {
          currentUserId: _vm.currentUser.id,
          currentUserRole: _vm.currentUser.role,
          filters: _vm.projectFilters,
          hideContractorsFilter: "",
          hideBudgetFilter: "",
        },
        on: {
          filtersChanged: _vm.updateFilters,
          filtersReset: _vm.resetFilters,
        },
      }),
      _vm.empty
        ? _c("EmptyListPlaceholder", {
            attrs: { title: _vm.emptyListMessage },
            scopedSlots: _vm._u(
              [
                {
                  key: "image",
                  fn: function () {
                    return [_c("EmptyListImageProjects")]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              4049957145
            ),
          })
        : [
            _c("p", { staticClass: "mb-6 text-sm font-normal" }, [
              _vm._v(" " + _vm._s(_vm.currentTotal) + " Total clients "),
            ]),
            _c(
              "div",
              { staticClass: "mb-4 flex flex-wrap gap-4" },
              _vm._l(_vm.projects, function (project) {
                return _c("ProjectCard", {
                  key: project.id,
                  attrs: {
                    projectDetailsRoute:
                      _vm.routeNames.CONTRACTOR_PROJECT_ACTIVITY,
                    project: project,
                    currentUser: _vm.currentUser,
                    isWithActivities: "",
                    hideDescription: "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activities",
                        fn: function ({
                          title,
                          startDate,
                          endDate,
                          budget,
                          requestedHours,
                          approvedHours,
                        }) {
                          return [
                            _c("ProjectActivitySmallCard", {
                              attrs: {
                                title: title,
                                startDate: startDate,
                                endDate: endDate,
                                budget: budget,
                                requestedHours: requestedHours,
                                approvedHours: approvedHours,
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              1
            ),
          ],
      _c("CardPagination", {
        attrs: { config: _vm.paginationConfig },
        on: {
          "update:config": function ($event) {
            _vm.paginationConfig = $event
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }